import React from "react";
import './taFormField.css';

export const TaFormFieldCaption = ({children}) => {
  return children ? <div className="ta-form-field__caption">{children}</div> : null;
};